<template>
    <div id="newSupportAlert" class="modal inmodal fade modal-v5">
        <div class="modal-dialog modal-sm">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                    <h4 class="modal-title">{{ t.title }}</h4>
                </div>
                <div class="modal-body">
                    <p class="content-text" v-html="t.message"></p>
                </div>
            </div>
        </div>
   </div>
</template>

<script>
export default {
    name: "new-support-alert",
    props: {
        view: {
            type: Object,
        }
    },
    data() {
        return {
            t: this.view.translations,
        }
    },
    methods: {
    },
    computed: {
    },
    watch: {
    },
    mounted(){
        let showModal = window.localStorage.getItem('new_support_alert_closed') == null;
        if (showModal) {
            $("#newSupportAlert").modal('show');
            window.localStorage.setItem('new_support_alert_closed', '1');
        }
    }
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/modal/NewSupportAlert.vue